import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { fetchTsIds } from './shared/parallelFetch'
import { useToFill } from './shared/useToFill'

export function useYearlyNormals(ghId, tsIds) {
  const queryKey = ['yearlyNormals', ghId, tsIds]

  const { data, isLoading, isError } = useQuery({
    queryKey,
    queryFn: async () => {
      const empty = { data: [], to_fill: [] }
      const responses = await fetchTsIds(
        tsIds,
        tsId => api.get(`/sndata_ts?ts_id=${tsId}&gh_id=${ghId}&stype=YEAR`).catch(() => empty),
        true
      )
      const result = responses.map(r => r?.data ?? [])
      const toFill = responses.flatMap(r => r?.to_fill ?? [])
      return { result, toFill }
    },
    enabled: !!ghId && tsIds.length > 0,
    staleTime: 60 * 60 * 1000,
  })

  useToFill(queryKey, data, (result, resp, item) => {
    const i = tsIds.indexOf(item.params?.ts_id)
    if (i < 0) return result
    const next = result.slice()
    next[i] = resp.data
    return next
  }, { gran: 'YEAR', live: false })   // normály — dlouhodobé agregáty, nikdy „živé"

  const normalsMap = {}
  if (data?.result) {
    tsIds.forEach((tsId, i) => {
      const rows = data.result[i] ?? []
      normalsMap[tsId] = rows.length > 0 ? (rows[0]?.average ?? null) : null
    })
  }

  return { normalsMap, isLoading, isError }
}
